import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { configurationSlice } from "../../../app/store/slices/configurationSlice";

const RequireAuth = ({ allowedRoles }) => {
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
  const dispatch = useDispatch();

  const decoded = auth?.accessToken ? jwtDecode(auth.accessToken) : null;
  const role = decoded?.sys_role;

  dispatch(configurationSlice.actions.initConnectedUser(decoded));

  return allowedRoles.includes(role) ? (
    <Outlet />
  ) : auth?.accessToken ? (
    <Navigate to="/unauthorized" replace />
  ) : (
    <Navigate to="/signin" state={{ from: location }} replace />
  );
};

export default RequireAuth;
